export const environment = {
  production: false,
  api: 'https://invoice-test.redbullsalzburg.at',
};
